import { Tag } from "src/containers/conversations/components/chat/hooks/useConversationsTags";
import { MPDIcon } from "../../mpd-library";
import styles from "./styles.module.scss";
import { ReactComponent as EnterIcon } from "../../mpd-library/icon/assets/enter-icon.svg"

const classname = "item";

type DropdownTagItemWithParentProps = {
    tag: Tag;
    tagsSearchValue: string;
    hideAccentor: boolean;
};

export const DropdownTagItemWithParent = ({
    tag,
    tagsSearchValue,
    hideAccentor = false
}: DropdownTagItemWithParentProps) => {
    const getHighlightedText = (text) => {
        // Split on highlight term and include term into parts, ignore case
        const parts = tagsSearchValue ? text.split(new RegExp(`(${tagsSearchValue})`, "gi")) : [text];
        return (
            <span className={styles[`${classname}-name`]}>
                {" "}
                {parts.length &&
                    parts.map((part, i) => (
                        <span
                            key={i}
                            style={
                                part?.toLowerCase() === tagsSearchValue.toLowerCase()
                                    ? { backgroundColor: "#FDCB6E", borderRadius: "3px", color: "black" }
                                    : {}
                            }
                        >
                            {part}
                        </span>
                    ))}{" "}
            </span>
        );
    };

    return (
        <div className={styles[classname]}>
            {!!tag.ancestors_formatted.length && hideAccentor && <MPDIcon IconComponent={EnterIcon} className={"left-icon"} />}
            <div className={styles[`${classname}-tag-label`]}>
                {tag.ancestors_formatted && !hideAccentor && (
                    <span className={styles[`${classname}-tag-ancestor`]}>{`${tag.ancestors_formatted} > `}</span>
                )}
                <span className={styles[`${classname}-tag-name`]}>{getHighlightedText(tag.name)}</span>
            </div>
        </div>
    );
};
